module.exports = __webpack_public_path__ + "static/heliofania-01-d25e247d8195af72c7830bffc0bca5b3.jpg";